import { render, staticRenderFns } from "./StudioDetails.vue?vue&type=template&id=8eb8cfa4&scoped=true&"
import script from "./StudioDetails.vue?vue&type=script&lang=js&"
export * from "./StudioDetails.vue?vue&type=script&lang=js&"
import style0 from "./StudioDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StudioDetails.vue?vue&type=style&index=1&id=8eb8cfa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb8cfa4",
  null
  
)

export default component.exports